import { EntityEditFormModal } from '../../Entity'

import { USER_EDIT_USERNAME_MODAL_QA_NAME } from './UserEditUsernameFormModal.constants'
import {
  getUserEditUsernameFormModalSubmitPayload,
  getUserEditUsernameFormModalValidationSchema,
} from './UserEditUsernameFormModal.utils'
import { UserEditUsernameFormModalFields } from './UserEditUsernameFormModalFields'

function UserEditUsernameFormModal({
  Fields = UserEditUsernameFormModalFields,
  formTitleKey = 'UserProfile.EditUsernameModalTitleKey',
  getPayload = getUserEditUsernameFormModalSubmitPayload,
  initialValues,
  ...restProps
}) {
  const validationSchema =
    getUserEditUsernameFormModalValidationSchema(initialValues)

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={Fields}
      formTitle={formTitleKey}
      getPayload={getPayload}
      initialValues={initialValues}
      qaName={USER_EDIT_USERNAME_MODAL_QA_NAME}
      validationSchema={validationSchema}
    />
  )
}

export default UserEditUsernameFormModal
